import classNames from 'classnames'
import React from 'react'
import { useAccordionContext } from '../AccordionContext'

export const AccordionHeader = ({ className, children, onClick, hideIcon, ...props }) => {
  const { toggle, visible, disableToggle } = useAccordionContext()
  const classes = classNames(['accordion-header', 'transition-regular', 'flex', 'ai-center jc-between', 'w-100', 'gap-4'], className, {
    '--selected': visible,
    'pointer-events-none': disableToggle,
  })
  const iconClassName = classNames(['accordion-icon', 'w-24', 'h-24'], {
    '--rotate': visible,
  })

  const handleClick = () => {
    if (disableToggle) return

    onClick?.()
    toggle?.()
  }

  return (
    <button className={classes} onClick={handleClick} {...props}>
      {children}
      {!hideIcon && (
        <i className={iconClassName}>
          <svg viewBox='0 0 16 17' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path fillRule='evenodd' clipRule='evenodd' d='M8.24267 9.13331L11.0713 6.30465C11.3316 6.04434 11.7537 6.04434 12.014 6.30465C12.2743 6.56496 12.2743 6.987 12.014 7.24731L8.94977 10.3115C8.55925 10.7021 7.92608 10.7021 7.53556 10.3115L4.47133 7.24731C4.21102 6.987 4.21102 6.56496 4.47133 6.30465C4.73164 6.04434 5.15369 6.04434 5.414 6.30465L8.24267 9.13331Z' fill='#272727' />
          </svg>
        </i>
      )}
    </button>
  )
}

export default AccordionHeader

